// ** Icons Import
import {
  Bookmark, Circle, TrendingUp, Settings, DollarSign, Type, User, UserCheck, Users, Edit, FileText, Printer
} from "react-feather";
import { LiaChalkboardTeacherSolid, } from "react-icons/lia";
import { MdMiscellaneousServices, MdDateRange, MdNotifications } from "react-icons/md";
import { AiOutlineVideoCamera, AiOutlineStar } from "react-icons/ai";
import { BiChat, BiCategory } from "react-icons/bi";
import Member from '../Icon/Member'
import Roles from "../Icon/Roles";
import Permission from '../Icon/Permission'
import { SiGoogleclassroom, SiSurveymonkey } from "react-icons/si";
export default [
  {
    id: "Hola",
    title: "Setups",
    icon: <Settings size={20} />,
    badge: "light-warning",
    children: [
 {
        id: "Video",
        title: "Video",
        icon: <AiOutlineVideoCamera />,
        navLink: "/Setup/Video",
        action: "read",
        resource: "Doctype-10",
        disableOnOffline: true,
      },
      {
              id: "Notification",
              title: "Notification",
              icon: <MdNotifications />,
              navLink: "/Setup/Notification",
              action: "read",
              resource: "Doctype-7",
              disableOnOffline: true,
            },
      {
        id: "VideoCategory",
        title: "VideoCategory",
        icon: <BiCategory />,
        navLink: "/Setup/VideoCategory",
        action: "read",
        resource: "Doctype-11",
        disableOnOffline: true,
      },
     {
        id: "Chat",
        title: "Chat",
        icon: <BiChat />,
        navLink: "/Setup/Chat",
        action: "read",
        resource: "Doctype-3",
        disableOnOffline: true,
      },
       {
        id: "Members",
        title: "Members",
        icon: <Member />,
        navLink: "/Setup/Members",
        action: "read",
        resource: "Doctype-5",
        disableOnOffline: true,
      },
      {
        id: "Instructores",
        title: "Instructors",
        icon: <LiaChalkboardTeacherSolid />,
        navLink: "/Setup/Instructores",
        action: "read",
        resource: "Doctype-4",
        disableOnOffline: true,
      },
      {
        id: "Talents",
        title: "Talents",
        icon: <AiOutlineStar />,
        navLink: "/Setup/Talents",
        action: "read",
        resource: "Doctype-8",
        disableOnOffline: true,
      },
     
      {
        id: "Appointments",
        title: "Appointments",
        icon: <MdDateRange />,
        navLink: "/Setup/Appointments",
        action: "read",
        resource: "Doctype-2",
        disableOnOffline: true,
      },
      
      {
        id: "Sesssions",
        title: "Sessions",
        icon: <SiGoogleclassroom />,
        navLink: "/Setup/Sesssions",
        action: "read",
        resource: "Doctype-15",
        disableOnOffline: true,
      },
       {
        id: "Services",
        title: "Services",
        icon: <MdMiscellaneousServices />,
        navLink: "/Setup/Services",
        action: "read",
        resource: "Doctype-7",
        disableOnOffline: true,
      },
      {
        id: "Survey",
        title: "Survey",
        icon: <SiSurveymonkey />,
        navLink: "/Setup/Survey",
        action: "read",
        resource: "Doctype-15",
        disableOnOffline: true,
      },
           {
        id: "Roles",
        title: "Roles",
        icon: <Roles />,
        navLink: "/Setup/Role",
        action: "read",
        resource: "Doctype-1",
        disableOnOffline: true,
      },
      {
        id: "Permission",
        title: "Permission",
        icon: <Permission />,
        navLink: "/Setup/Permission",
        action: "read",
        resource: "Doctype-6",
        disableOnOffline: true,
      },
      {
        id: "User",
        title: "User",
        icon: <User />,
        navLink: "/Setup/User",
        action: "read",
        resource: "Doctype-9",
        disableOnOffline: true,
      },
    ],
  },
];
